export enum SettingUnitType {
    UNITS = 'units',
    FAIL_SAFE = 'failsafe',
    DELIVERY_MODE = 'deliveryMode',
    FLIGHT_ALTITUDE = 'flightAltitude',
    DELIVERY_ALTITUDE = 'deliveryAltitude',
    DELIVERY_SPEED = 'deliverySpeed',
    MIN_RETURN_ALTITUDE = 'minReturnAltitude',
}